// extracted by mini-css-extract-plugin
export default {"container":"B4-z","heading":"C4-z","links":"D4-z","copy":"E4-z","subCopy":"F4-z","linksLeft":"G4-z","linksCenter":"H4-z","linksRight":"I4-z","link":"J4-z","onlyLink":"K4-z"};